import React, { useContext, useEffect, useState } from "react";
import "./styles.css"
import CloseIcon from '@mui/icons-material/Close';
import Context from "../../../../context/Context";

export const WagonTableCards = ({  handleRemovePeca, isEdit, data }) => {
  const {
    selectedCountry,
    selectedWagon,
    confirmedWagon,
    wagon
  } = useContext(Context);

  const tableBody = (key, pecas, wagonData) => {


    console.log("Peças", pecas);
    

    const jsonItens = {
      ordem_Part_Short: pecas.ordem_Part_Short,
      subProduto_Desc: pecas.subProduto_Desc,
      ordem_Serial: pecas.ordem_Serial,
      ordem_VehCod: `${pecas.ordem_VehDesc} - ${pecas.ordem_VehCod}`,
      bomba_B: pecas.bomba_B,
      formulaCod: pecas.formulaCod,
      m2_Peca: (pecas.m2_Peca / 4.5).toFixed(3) ,
      X: deletePeca(wagonData, pecas)
    };
    return jsonItens[key];
  };
  
  const itensWagon = [
    'ordem_Serial',
    'ordem_Part_Short',
    'subProduto_Desc',
    'bomba_B',
    'ordem_VehCod',
    'formulaCod',
    'm2_Peca',
    "X"
  ];
  
  const deletePeca = (wagonData, pecas) => {
    return <CloseIcon
      className="closeButton"
      onClick={isEdit.isEdit ? () =>  handleRemovePeca(wagonData, pecas)  : () => { }}
    />
  }

  return (
    <>
      {data.wagon.map((pecas, index) => (
        <tr key={index}>
          {itensWagon.map((item, subIndex) => (
            <td key={subIndex}>
              {tableBody(item, pecas, selectedWagon?.wagonInfo?.vagao_Key ? confirmedWagon : wagon)}
            </td>
          ))}
        </tr>
      ))}
    </>

  )
}